<template>
  <v-container>
    <v-img class="image2-position" width="30px" :src="image2"></v-img>
    <v-row class="d-flex justify-center">
      <v-col
        v-if="$root.isDesktop"
        cols="12"
        md="6"
        class="my-0 py-0 d-flex align-end"
      >
        <img class="background-register mb-n3" :src="background" />
      </v-col>
      <v-col cols="12" md="6" class="register">
        <v-container>
          <v-form ref="form" @submit.prevent="">
            <v-row dense class="mx-3">
              <v-col cols="12" class="text-center mb-1">
                <span class="title-font-secondary">{{ t("title") }}</span>
              </v-col>
              <v-col cols="12" md="6">
                <sc-text-field
                  v-model="model.firstName"
                  rule-required
                  :label="t('name')"
                ></sc-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <sc-text-field
                  rule-required
                  v-model="model.lastName"
                  :label="t('lastName')"
                ></sc-text-field>
              </v-col>
              <v-col cols="12">
                <sc-text-field
                  rule-required
                  rule-email
                  :error-messages="errors.email"
                  :label="t('email')"
                  v-model="model.email"
                  :messages="t('messages.email')"
                ></sc-text-field>
              </v-col>
              <v-col cols="12">
                <sc-text-field
                  rule-required
                  type="phone"
                  ref="phoneField"
                  :label="t('phone')"
                  v-model="model.phone"
                  :messages="t('messages.phone')"
                ></sc-text-field>
              </v-col>
              <v-col cols="12">
                <sc-text-field
                  rule-required
                  type="password"
                  :label="t('password')"
                  v-model="model.password"
                  :messages="t('messages.password')"
                ></sc-text-field>
              </v-col>
              <v-col cols="12">
                <sc-text-field
                  rule-required
                  type="password"
                  v-model="passwordConfirm"
                  :label="t('confirmPossword')"
                  :messages="t('messages.confirmPassword')"
                ></sc-text-field>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <v-alert
                  v-show="passwordNotMatch"
                  transition="scale-transition"
                  class="rounded-xl"
                  dense
                  text
                  type="error"
                  >{{ t("messages.passwordNotMatch") }}</v-alert
                >
              </v-col>
              <v-col cols="12" class="mt-2 d-flex flex-column align-center">
                <sc-btn :loading="loading" @click="submit" block>{{
                  t("save")
                }}</sc-btn>
                <div
                  v-if="!$root.isDesktop"
                  class="mt-3 text-decoration-underline primary--text"
                >
                  <sc-btn @click="$root.toLogin" text>{{
                    t("ihaveAccount")
                  }}</sc-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { SAVE_TOKEN, SAVE_USER } from "@/constants/mutations-type";
import { mapMutations } from "vuex";
export default {
  data: () => ({
    background: require("@/assets/images/background-register.png"),
    image2: require("@/assets/images/image-2.png"),
    model: {
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      password: null,
      lang: null,
    },
    errorsList: {},
    loading: null,
    passwordConfirm: null,
  }),
  computed: {
    passwordNotMatch: (vm) => {
      if (vm.model.password && !vm.passwordConfirm) return false;
      if (!vm.model.password && vm.passwordConfirm) return false;
      if (vm.model.password !== vm.passwordConfirm) return true;
      return false;
    },
    errors: (vm) =>
      Object.entries(vm.errorsList).reduce(
        (acc, [key]) => ({ [key]: vm.t(`errors.${key}`), ...acc }),
        {}
      ),
  },
  methods: {
    ...mapMutations("auth", [SAVE_TOKEN, SAVE_USER]),
    t(key, options = {}) {
      return this.$t(`public.signup.${key}`, options);
    },
    submit() {
      if (
        !this.$refs.form.validate() ||
        !this.$refs.phoneField.validate() ||
        this.passwordNotMatch
      )
        return;
      this.loading = true;
      this.model.lang = this.$store.state.config.lang;
      this.API.auth
        .signUp(this.model)
        .then(({ token }) => {
          this[SAVE_TOKEN](token.access_token);
          this.API.auth.me().then((userData) => {
            this[SAVE_USER](userData);
          });
          this.$router.push("/designer/create");
        })
        .catch((e) => {
          this.errorsList = e.response?.data || {};
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.register {
  max-width: 600px;
}
.background-register {
  width: 100%;
  height: 700px;
  object-fit: cover;
  object-position: 0px 100%;
}
.image2-position {
  position: absolute;
  top: 22%;
  right: 3%;
  z-index: 0;
}
</style>
